/**
 * The live AppServices behind a CommandContext. Command contexts are COPIES of the services (`{ ...services, when,
 * source }`), so their `store` / `engine` are snapshots and their identity changes on every run. This package keys its
 * per-app objects (stage, stage state, test play) on the editor store, whose identity is shared by every copy, and
 * resolves the live services object that the module's `init` and the panels registered.
 */

import type { AppServices } from '../../app/registry/types';

const live = new WeakMap<object, AppServices>();

/** Records the live services object (module init, panel mount). */
export function registerServices(services: AppServices): void {
  live.set(services.editor, services);
}

/** The live services for a services object or a command context (itself when none was registered). */
export function liveServices(services: AppServices): AppServices {
  return live.get(services.editor) ?? services;
}

/** Stable identity of an app instance (the key of per-app objects). */
export function appKey(services: AppServices): object {
  return services.editor;
}
